export enum RefereeView {
  MATCHES = 1,
  UNAVAILABILITY = 2,
  EXCUSED = 3,
  CALENDAR = 4,
  DETAIL = 5,
  LIST = 6,
  DELEGATIONS_FAVORITE = 7,
  DELEGATIONS_PERMISSIONS = 8,
  GROUP_DETAIL = 9,
  MATCH_DETAIL = 10,
  EMPTY = 11,
  LEAGUE_EMPTY = 12,
  ATTENDANCE_CONFIRM = 14,
}
